module.exports = __webpack_public_path__ + "static/media/logo_insurance.07579c67.svg";